module.exports = __webpack_public_path__ + "static/img/zhtsg-gjszhpt-01.5fb7308.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zhtsg-gjszhpt-01.png
// module id = f55H
// module chunks = 1